import React, { ReactNode } from 'react';
import { WprBaseViewInfo } from '../WprBaseViewInfo';
import { IWprViewProps } from '../props/IWprViewProps';
import { IWprViewState } from '../props/IWprViewState';
import { WprFramework } from '../../WprFramework';
import { WprRowInfo } from '../../component/props/WprRowInfo';
import { WprReflectUtil } from '../../util/WprReflectUtil';

/**
 * ビューコンポーネント基本クラス
 */
export abstract class WprBaseViewCoreComponent<T> extends React.Component<T, IWprViewState> {
	// private 変数  ------------------------------------------------------------
	private m_ViewInfo: WprBaseViewInfo 	= null;			// ビュー情報
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** ビュー情報 */
	public get view(): WprBaseViewInfo 	{ return this.m_ViewInfo; 	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor(viewInfo: WprBaseViewInfo, props: any) {
		super(props);
		this.m_ViewInfo = viewInfo;
		viewInfo.setScopeInfo();
		viewInfo.setComponent(this);
		viewInfo.initialize();
		this.state = {
			mode: {},
			data: {},
			listData: {},
			scopeMode: viewInfo.getScopeModeState(),
			scopeModel: viewInfo.getScopeModelState(),
			globalMode: viewInfo.getGlobalModeState(),
			globalModel: viewInfo.getGlobalModelState(),
		};
	}
	// --------------------------------------------------------------------------

	// abstract メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public abstract onRender(): ReactNode;
	// --------------------------------------------------------------------------

	// ライフサイクル  -----------------------------------------------------------
	/**
	 * マウント通知
	 */
	public componentDidMount() {
		this.m_ViewInfo.isMount = true;
		this.m_ViewInfo.showView();
	}

	/**
	 * 描画
	 */
	public render(): ReactNode {
		return this.onRender();
	}

	/**
	 * アンマウント通知
	 */
	public componentWillUnmount() {
		this.m_ViewInfo.isMount = false;
		this.m_ViewInfo.terminate();
	}
	// --------------------------------------------------------------------------

	// virtual メソッド  ---------------------------------------------------------
	/**
	 * リスト描画
	 * @param listName リスト名
	 * @param rowInfo 行情報
	 */
	protected onRenderList(listName: string, rowInfo: WprRowInfo): any {
	}
	// --------------------------------------------------------------------------

	// protected メソッド  -------------------------------------------------------
	/**
	 * リスト描画処理
	 * @param listName リスト名
	 */
	protected renderList(listName: string): any {
		if (WprReflectUtil.checkProperty(this.state.listData, listName) === true) {
			const listData = WprReflectUtil.getProperty(this.state.listData, listName) as any[];
			if (listData != null) {
				let list = new Array();
				listData.map((row, index) => {
					list.push(this.onRenderList(listName, new WprRowInfo(listName, index, row)));
				});
				return list;
			}
		}
		else {
			// error
		}
		return undefined;
	}
	// --------------------------------------------------------------------------
}
